import styled from 'styled-components'

import {
  ReferralCardInvite,
  ReferralCardInviteCode,
  ReferralCardReferrals,
  ReferralCardWithdraw,
} from '@root/features/referral/ui/common'
import { useAppRoutes } from '@root/features/routing'

export const ReferralBoard = () => {
  const { navigateToProfileReferralUsers } = useAppRoutes()

  return (
    <Root>
      <ReferralCardInvite />
      <ReferralCardReferrals
        onNavigateToReferrals={navigateToProfileReferralUsers}
      />
      <ReferralCardInviteCode />
      <ReferralCardWithdraw />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr);
  gap: 12px;
  align-content: start;
  padding: 16px;
`
